var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 11L7.83005 11L12.71 6.12002C13.1 5.73002 13.1 5.09002 12.71 4.70002C12.6175 4.60732 12.5076 4.53377 12.3867 4.48359C12.2657 4.43341 12.136 4.40758 12.005 4.40758C11.8741 4.40758 11.7444 4.43341 11.6234 4.48359C11.5024 4.53377 11.3926 4.60732 11.3 4.70002L4.71005 11.29C4.61734 11.3825 4.5438 11.4924 4.49361 11.6134C4.44343 11.7344 4.4176 11.8641 4.4176 11.995C4.4176 12.126 4.44343 12.2557 4.49361 12.3766C4.5438 12.4976 4.61734 12.6075 4.71005 12.7L11.29 19.3C11.3826 19.3926 11.4925 19.466 11.6135 19.5161C11.7345 19.5663 11.8641 19.592 11.995 19.592C12.126 19.592 12.2556 19.5663 12.3766 19.5161C12.4976 19.466 12.6075 19.3926 12.7 19.3C12.7926 19.2074 12.8661 19.0975 12.9162 18.9766C12.9663 18.8556 12.9921 18.726 12.9921 18.595C12.9921 18.4641 12.9663 18.3344 12.9162 18.2135C12.8661 18.0925 12.7926 17.9826 12.7 17.89L7.83005 13L19 13C19.55 13 20 12.55 20 12C20 11.45 19.55 11 19 11Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.5801d7287fb5cee05f47f50013c243a4.svg";
export { ForwardRef as ReactComponent };